import { endpoints, request } from '!core/api';

export const dbConfigurationsServices = {
  dbConfigurations: ({ parameterId }) =>
    request.get(endpoints.chnn(`wsbGetConfigsUi?parameterId=${parameterId}`)),
  dbConfigurationsNoAuth: ({ parameterId }) =>
    request.get(
      endpoints.chnn(`wsbGetConfigsUiNoAuth?parameterId=${parameterId}`),
    ),
};
